import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPagePamplona = props => {
  return <CityLandingPage cityKey="Pamplona" cityConfig={cityContent.pamplona} {...props} />;
};

export default LandingPagePamplona;
